Ext.define('SA.EditPanelDisabledSection', {
    alias: 'widget.edit-panel-disabled-section',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-edit-panel-disabled-section',

    initComponent() {
        this.items = [
            {
                xtype: 'component',
                cls: 'sa-edit-panel-disabled-section-header',
                html: this.message
            }, {
                xtype: 'simple-container',
                cls: 'sa-edit-panel-disabled-section-body',
                itemId: 'body'
            }
        ];

        this.callParent();

        this.body = this.down('#body');
    },

    eachItem(callback) {
        this.body.getChildItems().forEach(callback);
    },

    findItem(dataId) {
        return this.body.getChildItems().find(item => item.getDataId() === dataId);
    },

    syncItems(items) {
        this.body.syncItems(items);
    }
});